/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
import Store from "@material-ui/icons/Store";
// import InfoOutline from "@material-ui/icons/InfoOutline";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Refresh from "@material-ui/icons/Refresh";
import Edit from "@material-ui/icons/Edit";

import Language from "@material-ui/icons/Language";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Danger from "components/Typography/Danger.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardText from "components/Card/CardText";

import { ROLES_STRING } from 'constants/user';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';

import _ from 'lodash';

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts";

import {
  dangerColor,
  infoColor,
  grayColor,
} from "assets/jss/material-dashboard-pro-react.jsx";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import enbrainImage from "assets/img/enbrain.png";
import hanologo from "assets/img/hanohyuplogo.png";

import { ACTIVITY_LEVEL_LABELS } from "constants/form";


import legendPlugin from "chartist-plugin-legend";
import ctPointLabels from "chartist-plugin-pointlabels";


var mapData = {
  "KR-31": 760,
  "KR-49": 550,
  "KR-48": 120,
  "KR-42": 1300,
  "KR-27": 540,
  "KR-50": 690,
  "KR-28": 200,
  "KR-29": 200,
  "KR-30": 600,
  "KR-43": 300,
  "KR-11": 2920,
  "KR-41": 2000,
};




class DashboardForAssociation extends React.Component {
  state = {
    value: 0
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  componentDidMount() {
    if (!this.unsubscribeStatistics) {
      this.unsubscribeStatistics = this.props.watchingStatistics('global');
    }
  }


  componentWillUnmount() {
    if (this.unsubscribeStatistics) {
      this.unsubscribeStatistics();
    }
  }

  demographicPivotInfo = () => {
    const { demographicPivot = [] } = this.props.statistics;
    const grouped_demographicPivot = _.groupBy(demographicPivot, "age_group");

    const sumCount1 = Object.keys(grouped_demographicPivot).map(key =>
      _(grouped_demographicPivot[key])
        .filter(obj => obj.gender === 1)
        .sumBy('count'));

    const sumCount0 = Object.keys(grouped_demographicPivot).map(key =>
      _(grouped_demographicPivot[key])
        .filter(obj => obj.gender === 0)
        .sumBy('count'));

    return {
      data: {
        labels: Object.keys(grouped_demographicPivot),
        series: [
          { "name": "남", "data": sumCount1 },
          { "name": "여", "data": sumCount0 }
        ]
      },
      options: {
        axisX: {
          showGrid: true
        },
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0
        },
        plugins: [
          // legendPlugin(),
          // ctPointLabels({
          //   textAnchor: 'middle',
          //   labelOffset: {
          //     x: 0,
          //     y: -100
          //   },
          // })
        ]
      }
    }
  }

  genderPieChartInfo = () => {

    const { genderRatio = [] } = this.props.statistics;
    return {
      data: {
        labels: genderRatio.map(obj => obj.gender === 1 ? "남" : "여"),
        series: genderRatio.map(obj => ({ value: obj.rate }))
      },
      options: {
        // height: "100px",
        // donut: true
        chartPadding: 30,
        labelOffset: 40,
        labelDirection: 'explode'
      }
    }
  }

  agesPieChartInfo = () => {
    const { ageRangeRatio = [] } = this.props.statistics;

    return {
      data: {
        labels: ageRangeRatio.map(obj => obj.age_group),
        series: ageRangeRatio.map(obj => obj.rate),
      },
      options: {
        // height: "100px",
        // donut: true
        chartPadding: 30,
        labelOffset: 40,
        labelDirection: 'explode'
      }
    }
  }

  activityLevelChartInfo = () => {
    const { activityLevelRatio = [] } = this.props.statistics;
    return {
      data: {
        labels: activityLevelRatio.map(obj => ACTIVITY_LEVEL_LABELS[obj.activity_level]),
        series: activityLevelRatio.map(obj => obj.rate),
      },
      options: {
        // height: "100px",
        // donut: true
        chartPadding: 30,
        labelOffset: 40,
        labelDirection: 'explode'
      }
    }
  }

  activityLevelPivotInfo = () => {
    const { activityLevelPivot = [] } = this.props.statistics;
    const grouped_activityLevelPivot = _.groupBy(activityLevelPivot, "activity_level");
    console.log("grouped_activityLevelPivot = ", grouped_activityLevelPivot);

    const sumCount1 = Object.keys(grouped_activityLevelPivot).map(key =>
      _(grouped_activityLevelPivot[key])
        .filter(obj => obj.gender === 1)
        .sumBy('count'));

    const sumCount0 = Object.keys(grouped_activityLevelPivot).map(key =>
      _(grouped_activityLevelPivot[key])
        .filter(obj => obj.gender === 0)
        .sumBy('count'));


    return {
      data: {
        labels: ACTIVITY_LEVEL_LABELS,
        series: [
          sumCount1,
          sumCount0
        ]
      },
      options: {
        axisX: {
          showGrid: true
        },
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0
        },
        plugins: [
          // legendPlugin({
          //   legendNames: ['남', '여']
          // })
        ]
      }
    }
  }

  avg_siadl = () => {
    const { avgS_IADL = [] } = this.props.statistics;
    if (avgS_IADL.length > 0) {
      return Math.round(avgS_IADL[0].avg_score);
    } else {
      return "loading...";
    }
  }

  avg_sadl = () => {
    const { avgS_ADL = [] } = this.props.statistics;
    if (avgS_ADL.length > 0) {
      return Math.round(avgS_ADL[0].avg_score);
    } else {
      return "loading...";
    }
  }

  mmse_dsPivotInfo = () => {
    const { mmse_dsPivot = [] } = this.props.statistics;
    const grouped_mmse_dsPivot = _.groupBy(mmse_dsPivot, "educated_years");
    console.log("grouped_mmse_dsPivot = ", grouped_mmse_dsPivot);

    const sumCount1 = Object.keys(grouped_mmse_dsPivot).map(key =>
      _(grouped_mmse_dsPivot[key])
        .filter(obj => obj.gender === 1)
        .meanBy('avg_score'));

    const sumCount0 = Object.keys(grouped_mmse_dsPivot).map(key =>
      _(grouped_mmse_dsPivot[key])
        .filter(obj => obj.gender === 0)
        .meanBy('avg_score'));


    return {
      data: {
        labels: ["0~3년", "4~6년(초졸)", "7~12년(중고졸)", "13년이상(대학이상)"],
        series: [
          sumCount1,
          sumCount0
        ]
      },
      options: {
        axisX: {
          showGrid: true
        },
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0
        }
      }
    }
  }

  mmse_dsByAgeGroupPivotInfo = () => {
    const { mmse_dsPivotByAgeGroup = [] } = this.props.statistics;
    const grouped_stat = _.groupBy(mmse_dsPivotByAgeGroup, "age_group");

    const sumCount1 = Object.keys(grouped_stat).map(key =>
      _(grouped_stat[key])
        .filter(obj => obj.gender === 1)
        .meanBy('avg_score'));

    const sumCount0 = Object.keys(grouped_stat).map(key =>
      _(grouped_stat[key])
        .filter(obj => obj.gender === 0)
        .meanBy('avg_score'));

    return {
      data: {
        labels: Object.keys(grouped_stat),
        series: [
          sumCount1,
          sumCount0
        ]
      },
      options: {
        axisX: {
          showGrid: true
        },
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0
        }
      }
    }
  }

  avg_mmse_ds = () => {
    const { avgMMSE_DS = [] } = this.props.statistics;
    if (avgMMSE_DS.length > 0) {
      return Math.round(avgMMSE_DS[0].avg_score) || "N/A";
    } else {
      return "loading...";
    }
  }

  avgGDS_Short = () => {
    const { avgGDS_Short = [] } = this.props.statistics;
    if (avgGDS_Short.length > 0) {
      return Math.round(avgGDS_Short[0].avg_score) || "N/A";
    } else {
      return "loading...";
    }
  }


  s_iadlPivotInfo = () => {
    const { s_iadlPivot = [] } = this.props.statistics;
    const grouped_stat = _.groupBy(s_iadlPivot, "name");

    const sumCount1 = Object.keys(grouped_stat).map(key =>
      _(grouped_stat[key])
        .filter(obj => obj.gender === 1)
        .meanBy('avg_score'));

    const sumCount0 = Object.keys(grouped_stat).map(key =>
      _(grouped_stat[key])
        .filter(obj => obj.gender === 0)
        .meanBy('avg_score'));

    return {
      data: {
        labels: Object.keys(grouped_stat),
        series: [
          sumCount1,
          sumCount0
        ]
      },
      options: {
        axisX: {
          showGrid: true
        },
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0
        }
      }
    }
  }

  s_adlPivotInfo = () => {
    const { s_adlPivot = [] } = this.props.statistics;
    const grouped_stat = _.groupBy(s_adlPivot, "name");

    const sumCount1 = Object.keys(grouped_stat).map(key =>
      _(grouped_stat[key])
        .filter(obj => obj.gender === 1)
        .meanBy('avg_score'));

    const sumCount0 = Object.keys(grouped_stat).map(key =>
      _(grouped_stat[key])
        .filter(obj => obj.gender === 0)
        .meanBy('avg_score'));

    return {
      data: {
        labels: Object.keys(grouped_stat),
        series: [
          sumCount1,
          sumCount0
        ]
      },
      options: {
        axisX: {
          showGrid: true
        },
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0
        }
      }
    }
  }

  gds_shortPivotInfo = () => {
    const { gds_shortPivot = [] } = this.props.statistics;
    const grouped_stat = _.groupBy(gds_shortPivot, "name");

    const sumCount1 = Object.keys(grouped_stat).map(key =>
      _(grouped_stat[key])
        .filter(obj => obj.gender === 1)
        .meanBy('avg_score'));

    const sumCount0 = Object.keys(grouped_stat).map(key =>
      _(grouped_stat[key])
        .filter(obj => obj.gender === 0)
        .meanBy('avg_score'));

    return {
      data: {
        labels: Object.keys(grouped_stat),
        series: [
          sumCount1,
          sumCount0
        ]
      },
      options: {
        axisX: {
          showGrid: true
        },
        chartPadding: {
          top: 0,
          right: 5,
          bottom: 0,
          left: 0
        }
      }
    }
  }

  render() {
    const { classes, currentRole } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <GridContainer>
              <div style={{
                backgroundColor: dangerColor[0],
                borderRadius: 10,
                width: 20,
                height: 20,
                marginRight: "8px"
              }}></div><span>한국노인종합복지관협회</span>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="danger" stats text>
                <CardText color="danger">
                  <div className={classes.titleLogoContainer}>
                    <img src={hanologo} className={classes.titleLogo} />
                    <h3 className={classes.cardTitle}>
                      엔브레인플랫폼 회원 기관
                    </h3>
                  </div>
                </CardText>
              </CardHeader>
              <CardBody>
                <GridContainer align="center">
                  <GridItem xs={12}>
                    <div style={{
                      color: dangerColor[0],
                      fontSize: '2.5em',
                      fontWeight: '400',
                    }}>{this.props.org.orgs && this.props.org.orgs.length.toString().padStart(3, '0')} / 301</div>
                    <div style={{
                      color: grayColor[0],
                      marginTop: 10,
                      fontSize: '0.9em',
                      marginLeft: 45,
                    }}>앤브레인플랫폼 회원기관 / 한국노인종합복지관협회 회원기관</div>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="danger" stats text>
                <CardText color="danger">
                  <div className={classes.titleLogoContainer}>
                    <img src={hanologo} className={classes.titleLogo} />
                    <h3 className={classes.cardTitle}>
                      회원기관 및 지회 현황
                    </h3>
                  </div>
                </CardText>
              </CardHeader>
              <CardBody>
                <GridContainer align="center">
                  <GridItem xs={12}>
                    <div style={{
                      color: dangerColor[0],
                      fontSize: '2.5em',
                      fontWeight: '400',
                    }}>301 / 364</div>
                    <div style={{
                      color: grayColor[0],
                      marginTop: 10,
                      fontSize: '0.9em',
                      marginRight: 100,
                    }}>한국노인종합복지관협회 회원기관 / 전국노인복지관</div>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="danger" stats text>
                <CardText color="danger">
                  <div className={classes.titleLogoContainer}>
                    <img src={hanologo} className={classes.titleLogo} />
                    <h3 className={classes.cardTitle}>
                      엔브레인플랫폼 우수 기관 랭킹
                    </h3>
                  </div>
                </CardText>
              </CardHeader>
              <CardBody>
                <GridContainer justify="center">
                  <GridItem xs={12}
                    style={{ margin: 20 }}
                  >
                    <Table
                      tableData={[
                        {
                          color: "danger",
                          data: [
                            "김포시노인종합복지관",
                            // "2.920",
                            "53.23"
                          ]
                        },
                        [
                          "신곡노인종합복지관",
                          // "1.300",
                          "20.43"
                        ],
                        [
                          "동두천시노인복지관",
                          // "760",
                          "10.35"
                        ],
                        [
                          "함지노인복지관",
                          // "690",
                          "7.87"
                        ],
                        [
                          "판교노인종합복지관",
                          // "600",
                          "5.94"
                        ],
                        // [
                        //   "안양시노인종합복지관",
                        //   "550",
                        //   "4.34%"
                        // ]
                      ]}
                      coloredColls={[1]}
                      colorsColls={["danger"]}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="danger" stats text>
                <CardText color="danger">
                  <div className={classes.titleLogoContainer}>
                    <img src={hanologo} className={classes.titleLogo} />
                    <h3 className={classes.cardTitle}>
                      엔브레인플랫폼 지역별 통계
                    </h3>
                  </div>
                </CardText>
              </CardHeader>
              <CardBody>
                <VectorMap
                  map={"kr_mill"}
                  backgroundColor="transparent"
                  zoomOnScroll={false}
                  containerStyle={{
                    width: "100%",
                    height: "280px"
                  }}
                  containerClassName="map"
                  regionStyle={{
                    initial: {
                      fill: "#e4e4e4",
                      "fill-opacity": 0.9,
                      stroke: "none",
                      "stroke-width": 0,
                      "stroke-opacity": 0
                    }
                  }}
                  series={{
                    regions: [
                      {
                        values: mapData,
                        scale: ["#AAAAAA", "#444444"],
                        normalizeFunction: "polynomial"
                      }
                    ]
                  }}
                />
              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12}>
            <GridContainer>
              <div style={{
                backgroundColor: infoColor[0],
                borderRadius: 10,
                width: 20,
                height: 20,
                marginRight: "8px"
              }}></div><span>노인맞춤돌봄서비스 사례관리</span>
            </GridContainer>
          </GridItem>

          <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="info" stats text>
                <div className={classes.rowDirection}>
                  <CardText color="info">
                    <h3 className={classes.cardTitle}>
                      [사례관리1]초기상담기록
                     </h3>
                  </CardText>
                  <div className={classes.legendBox}>
                    <div className={classes.legendInfoBox} />남 <div className={classes.legendDangerBox} />여
                  </div>
                </div>
              </CardHeader>
              <CardBody className={classes.cardBody}>
                <ChartistGraph
                  className={'ct-double-octave'}
                  data={this.demographicPivotInfo().data}
                  type="Bar"
                  options={this.demographicPivotInfo().options}
                />
              </CardBody>
              <CardFooter stats className={classes.cardFooter}>
                <div className={classes.bottomDescription}>
                  <Icon>info</Icon> 초기상담기록지 <br />
                  <Icon>info</Icon> 연령대별 남녀성비
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          {/* <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <Icon>content_copy</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>대상자 통계</p>
                <h3 className={classes.cardTitle}>
                  남녀성비
                </h3>
                <ChartistGraph
                  data={this.genderPieChartInfo().data}
                  type="Pie"
                  options={this.genderPieChartInfo().options}
                />

              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>info</Icon>
                  초기상담기록지(서식1) 전체참여자 대비 비율
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <Icon>content_copy</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>대상자 통계</p>
                <h3 className={classes.cardTitle}>
                  연령비율
                </h3>
                <ChartistGraph
                  data={this.agesPieChartInfo().data}
                  type="Pie"
                  options={this.agesPieChartInfo().options}
                />

              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>info</Icon>
                  초기상담기록지(서식1) 전체참여자 대비 비율
                </div>
              </CardFooter>
            </Card>
          </GridItem> */}
          <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="info" stats text>
                <div className={classes.rowDirection}>
                  <CardText color="info">
                    <h3 className={classes.cardTitle}>
                      [사례관리2-2]활동수준점검
                    </h3>
                  </CardText>
                  <div className={classes.legendBox}>
                    <div className={classes.legendWarningBox} />비율<div className={classes.legendInfoBox} />남(인원) <div className={classes.legendDangerBox} />여(인원)
                  </div>
                </div>
              </CardHeader>
              <CardBody className={classes.cardBody}>
                <ChartistGraph
                  className={'ct-double-octave'}
                  data={this.activityLevelPivotInfo().data}
                  type="Bar"
                  options={this.activityLevelPivotInfo().options}
                />

              </CardBody>
              <CardFooter stats className={classes.cardFooter}>
                <div className={classes.bottomDescription}>
                  <Icon>info</Icon> 활동수준점검 <br />
                  <Icon>info</Icon> 활동수준별 남녀비율
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          {/* <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <Icon>content_copy</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>활동수준</p>
                <h3 className={classes.cardTitle}>
                  활동수준 비율
                </h3>
                <ChartistGraph
                  data={this.activityLevelChartInfo().data}
                  type="Pie"
                  options={this.activityLevelChartInfo().options}
                />

              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>info</Icon>
                  활동수준점검표(서식2-2) 전체참여자 대비 비율
                </div>
              </CardFooter>
            </Card>
          </GridItem> */}
          {/* <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Icon>
                    score
                    </Icon>
                </CardIcon>
                <p className={classes.cardCategory}>간이정신상태 검사 평균점수</p>
                <h3 className={classes.cardTitle}>
                  {this.avg_mmse_ds()}<small>점</small> / 30<small> 만점</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>info</Icon>
                  간이정신상태 검사(서식2-3) 전체 참여자 평균
                </div>
              </CardFooter>
            </Card>
          </GridItem> */}
          <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="info" stats text>
                <div className={classes.rowDirection}>
                  <CardText color="info">
                    <h3 className={classes.cardTitle}>
                      [사례관리2-3]간이정신상태 검사
                    </h3>
                  </CardText>
                  <div className={classes.legendBox}>
                    <div className={classes.legendWarningBox} />MMSE-DS<div className={classes.legendInfoBox} />남 <div className={classes.legendDangerBox} />여
                  </div>
                </div>
              </CardHeader>
              <CardBody className={classes.cardBody}>
                <ChartistGraph
                  className={'ct-double-octave'}
                  data={this.mmse_dsPivotInfo().data}
                  type="Bar"
                  options={this.mmse_dsPivotInfo().options}
                />
              </CardBody>
              <CardFooter stats className={classes.cardFooter}>
                <div className={classes.bottomDescription}>
                  <Icon>info</Icon> 간이정신상태 검사 교육년수 별 성별 인원 <br />
                  <Icon>info</Icon> 교육년수 별 성별 인원 및 MMSE-DS 평균 점수
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="info" stats text>
                <div className={classes.rowDirection}>

                  <CardText color="info">
                    <h3 className={classes.cardTitle}>
                      [사례관리2-3]간이정신상태 검사
                    </h3>
                  </CardText>
                  <div className={classes.legendBox}>
                    <div className={classes.legendWarningBox} />MMSE-DS<div className={classes.legendInfoBox} />남 <div className={classes.legendDangerBox} />여
                  </div>
                </div>
              </CardHeader>
              <CardBody className={classes.cardBody}>
                <ChartistGraph
                  className={'ct-double-octave'}
                  data={this.mmse_dsByAgeGroupPivotInfo().data}
                  type="Bar"
                  options={this.mmse_dsByAgeGroupPivotInfo().options}
                />
              </CardBody>
              <CardFooter stats className={classes.cardFooter}>
                <div className={classes.bottomDescription}>
                  <Icon>info</Icon> 간이정신상태 검사 연령 별 성별 인원 <br />
                  <Icon>info</Icon> 연령별 성별 인원 및 MMSE-DS 평균 점수
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="info" stats text>
                <div className={classes.rowDirection}>
                  <CardText color="info">
                    <h3 className={classes.cardTitle}>
                      [사례관리2-6]수단적 일상생활활동
                    </h3>
                  </CardText>
                  <div className={classes.legendBox}>
                    <div className={classes.legendWarningBox} />전체평균<div className={classes.legendInfoBox} />남 <div className={classes.legendDangerBox} />여
                  </div>
                </div>
              </CardHeader>

              <CardBody>
                <div className={classes.averageArea}>
                  <div className={classes.averageBox}>전체 평균 점수: {this.avg_siadl()}</div>
                </div>
                <ChartistGraph
                  className={'ct-double-octave'}
                  data={this.s_iadlPivotInfo().data}
                  type="Bar"
                  options={this.s_iadlPivotInfo().options}
                />
              </CardBody>

              <CardFooter stats className={classes.cardFooter}>
                <div className={classes.bottomDescription}>
                  <Icon>info</Icon> 수단적일상생활활동 <br />
                  <Icon>info</Icon> 수단적 일상생활활동 전체 평균 점수 대비 기관별 평균 점수
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          {/* <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Icon>score</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>수단적 일상 생활 활동</p>
                <h3 className={classes.cardTitle}>
                  {this.avg_siadl()} <small>점</small> / 45 <small>만점</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>info</Icon>
                  수단적 일상 생활활동(서식2-6) 전체 참여자 평균
                </div>
              </CardFooter>
            </Card>
          </GridItem> */}
          <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="info" stats text>
                <div className={classes.rowDirection}>
                  <CardText color="info">
                    <h3 className={classes.cardTitle}>
                      [사례관리2-7]기본적 일상생활활동
                    </h3>
                  </CardText>
                  <div className={classes.legendBox}>
                    <div className={classes.legendWarningBox} />전체평균<div className={classes.legendInfoBox} />남 <div className={classes.legendDangerBox} />여
                  </div>
                </div>
              </CardHeader>

              <CardBody>
                <div className={classes.averageArea}>
                  <div className={classes.averageBox}>전체 평균 점수: {this.avg_sadl()}</div>
                </div>

                <ChartistGraph
                  className={'ct-double-octave'}
                  data={this.s_adlPivotInfo().data}
                  type="Bar"
                  options={this.s_adlPivotInfo().options}
                />
              </CardBody>

              <CardFooter stats className={classes.cardFooter}>
                <div className={classes.bottomDescription}>
                  <Icon>info</Icon> 기본적 일상생활활동 <br />
                  <Icon>info</Icon> 기본적 일상생활활동 전체 평균 점수 대비 기관별 평균 점수
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          {/* <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Icon>score</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>기본적 일상 생활 활동</p>
                <h3 className={classes.cardTitle}>
                  {this.avg_sadl()}<small>점</small> / 24 <small>만점</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>info</Icon>
                  기본적 일상 생활활동(서식2-7) 전체 참여자 평균
                </div>
              </CardFooter>
            </Card>
          </GridItem> */}
          <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="info" stats text>
                <div className={classes.rowDirection}>
                  <CardText color="info">
                    <h3 className={classes.cardTitle}>
                      [사례관리2-10]정서
                    </h3>
                  </CardText>
                  <div className={classes.legendBox}>
                    <div className={classes.legendWarningBox} />전체평균<div className={classes.legendInfoBox} />남 <div className={classes.legendDangerBox} />여
                  </div>
                </div>
              </CardHeader>

              <CardBody>
                <div className={classes.averageArea}>
                  <div className={classes.averageBox}>전체 평균 점수: {this.avgGDS_Short()}</div>
                </div>
                <ChartistGraph
                  className={'ct-double-octave'}
                  data={this.gds_shortPivotInfo().data}
                  type="Bar"
                  options={this.gds_shortPivotInfo().options}
                />
              </CardBody>

              <CardFooter stats className={classes.cardFooter}>
                <div className={classes.bottomDescription}>
                  <Icon>info</Icon> 정서 <br />
                  <Icon>info</Icon> 정서 전체 평균 점수 대비 기관별 평균 점수
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          {/* <GridItem xs={12} sm={6} md={6} lg={6} className={classes.grid}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Icon>score</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>정서</p>
                <h3 className={classes.cardTitle}>
                  {this.avgGDS_Short()} <small>점</small> / 15 <small>만점</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Icon>info</Icon>
                  정서(서식2-10) 전체 참여자 평균
                </div>
              </CardFooter>
            </Card>
          </GridItem> */}
          {/* <GridItem xs={12} sm={6} md={6} lg={4} className={classes.grid}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <i className="fab fa-twitter" />
                </CardIcon>
                <p className={classes.cardCategory}>엔브레인 구동횟수 </p>
                <h3 className={classes.cardTitle}>
                  245 <small>회</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Update />
                  엔브래인 앱으로 치매예방활동 수행횟수
                </div>
              </CardFooter>
            </Card>
          </GridItem> */}
        </GridContainer>
        {/* <GridContainer>
          <GridItem xs={12} sm={12} md={4} className={classes.grid}>
            <Card chart className={classes.cardHover}>
              <CardHeader color="info" className={classes.cardHeaderHover}>
                <ChartistGraph
                  className="ct-chart-white-colors"
                  data={dailySalesChart.data}
                  type="Line"
                  options={dailySalesChart.options}
                  listener={dailySalesChart.animation}
                />
              </CardHeader>
              <CardBody>
                <div className={classes.cardHoverUnder}>
                  <Tooltip
                    id="tooltip-top"
                    title="Refresh"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button simple color="info" justIcon>
                      <Refresh className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    id="tooltip-top"
                    title="Change Date"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button color="transparent" simple justIcon>
                      <Edit className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                </div>
                <h4 className={classes.cardTitle}>Daily Sales</h4>
                <p className={classes.cardCategory}>
                  <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                  </span>{" "}
                  increase in today sales.
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> updated 4 minutes ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} className={classes.grid}>
            <Card chart className={classes.cardHover}>
              <CardHeader color="warning" className={classes.cardHeaderHover}>
                <ChartistGraph
                  className="ct-chart-white-colors"
                  data={emailsSubscriptionChart.data}
                  type="Bar"
                  options={emailsSubscriptionChart.options}
                  responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <div className={classes.cardHoverUnder}>
                  <Tooltip
                    id="tooltip-top"
                    title="Refresh"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button simple color="info" justIcon>
                      <Refresh className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    id="tooltip-top"
                    title="Change Date"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button color="transparent" simple justIcon>
                      <Edit className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                </div>
                <h4 className={classes.cardTitle}>Email Subscriptions</h4>
                <p className={classes.cardCategory}>
                  Last Campaign Performance
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent 2 days ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} className={classes.grid}>
            <Card chart className={classes.cardHover}>
              <CardHeader color="danger" className={classes.cardHeaderHover}>
                <ChartistGraph
                  className="ct-chart-white-colors"
                  data={completedTasksChart.data}
                  type="Line"
                  options={completedTasksChart.options}
                  listener={completedTasksChart.animation}
                />
              </CardHeader>
              <CardBody>
                <div className={classes.cardHoverUnder}>
                  <Tooltip
                    id="tooltip-top"
                    title="Refresh"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button simple color="info" justIcon>
                      <Refresh className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    id="tooltip-top"
                    title="Change Date"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button color="transparent" simple justIcon>
                      <Edit className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                </div>
                <h4 className={classes.cardTitle}>Completed Tasks</h4>
                <p className={classes.cardCategory}>
                  Last Campaign Performance
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent 2 days ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer> */}
        {/* <h3>언론에 나타난 캐어유</h3>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={4} className={classes.grid}>
            <Card product>
              <CardHeader image className={classes.cardHeaderHover}>
                <a href="http://www.newsprime.co.kr/news/article/?no=358069">
                  <img src="http://cdn.newsprime.co.kr/data/photos/cdn/20161250/art_1481702421.png" alt="..." />
                </a>
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardProductTitle}>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    검지 끝 세상서 세대 화합 '캐어유'
                  </a>
                </h4>
                <p className={classes.cardProductDesciprion}>
                  사회적기업 캐어유는 지난해 7월부터 고령층들이 가장 관심 두는 노인치매나 우울증 예방을 돕는 콘텐츠 개발 및 스마트폰 활용 교육을 전개 중이다.
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} className={classes.grid}>
            <Card product>
              <CardHeader image className={classes.cardHeaderHover}>
                <a href="https://www.youtube.com/watch?v=xjpF-hKzqwM">
                  <img src="https://i.ytimg.com/vi/xjpF-hKzqwM/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDUt8YgGjw4YUZifAWBHWJWkTs5Hg" alt="..." />
                </a>
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardProductTitle}>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    「KT&G복지재단」 제16회 전국 어르신 탁구대회 조 주첨
                  </a>
                </h4>
                <p className={classes.cardProductDesciprion}>
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} className={classes.grid}>
            <Card product>
              <CardHeader image className={classes.cardHeaderHover}>
                <a href="https://play.google.com/store/apps/details?id=org.enbrain.sksunny">
                  <img src={enbrainImage} alt="..." />
                </a>
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardProductTitle}>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    앤브레인 앱 다운로드
                  </a>
                </h4>
                <p className={classes.cardProductDesciprion}>
                  엔브레인(SK SUNNY)- “하루5분 두뇌활력 트레이닝프로그램” 젊은 사람도 치매에 걸릴 수 있어요. 치매엔 예외없다! 계속해서 추가되는 다양한 두뇌훈련 프로그램을 즐겨보세요~ 치매와 뇌질환은 예방하고 지연될 수 있어요! 기억력, 인지능력을 쑥쑥 키워보세요!
                </p>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer> */}
      </div>
    );
  }
}

DashboardForAssociation.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
  return {
    members: state.member.members,
    org: state.org,
    currentOrg: state.org.currentOrg,
    currentRole: state.auth.currentRole,
    statistics: state.statistics,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withStyles(dashboardStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(DashboardForAssociation);